import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/stake.png';
import _imports_1 from '@/assets/images/logo/zokyo.svg';
import _imports_2 from '@/assets/images/logo/certik.svg';
import _imports_3 from '@/assets/images/icons/gain.png';
import _imports_4 from '@/assets/images/announcelogo.webp';
const _withScopeId = n => (_pushScopeId("data-v-293d30b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "section-padding pt-0 horizontal-accordion bg-light-gray"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "28px",
    "height": "28px"
  },
  class: "mr-2",
  alt: ""
}, null, -1));
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "fw-medium fsi-16 mr-2",
  style: {
    "color": "#3d3d3d"
  }
};
const _hoisted_6 = {
  class: "fw-bold fsi-16"
};
const _hoisted_7 = {
  class: "row"
};
const _hoisted_8 = {
  class: "col-xl-7 col-12 order-xl-1 order-2"
};
const _hoisted_9 = {
  class: "pt-4"
};
const _hoisted_10 = {
  class: "pl-4 pr-4 pt-3 pb-4 border-radius-20 dashboard-card stake-bg"
};
const _hoisted_11 = {
  class: "stake-left-top"
};
const _hoisted_12 = {
  class: "font-fit fw-bold",
  style: {
    "color": "#6752F0"
  }
};
const _hoisted_13 = {
  key: 0,
  class: "font-fit-sub"
};
const _hoisted_14 = {
  class: "fsi-48 fw-extra-bold",
  style: {
    "line-height": "1.1",
    "color": "#6752F0"
  }
};
const _hoisted_15 = {
  class: "fsi-14 d-flex align-items-center",
  style: {
    "color": "#6752F0",
    "line-height": "1.6"
  }
};
const _hoisted_16 = {
  class: "mr-1 apr-tip"
};
const _hoisted_17 = {
  class: "stake-left-top-content"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "rgba(231,231,231,0.7)",
    "margin-top": "35px"
  }
}, null, -1));
const _hoisted_19 = {
  class: "stake-left-bottom"
};
const _hoisted_20 = {
  class: "row"
};
const _hoisted_21 = {
  class: "col-lg-6 col-12"
};
const _hoisted_22 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_23 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_24 = {
  class: "fw-bold fsi-24"
};
const _hoisted_25 = {
  class: "fw-bold fsi-24"
};
const _hoisted_26 = {
  style: {
    "margin-left": "-8px",
    "margin-top": "8px",
    "height": "24px"
  }
};
const _hoisted_27 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_28 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_29 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_30 = {
  class: "fw-bold fsi-24"
};
const _hoisted_31 = {
  class: "fw-bold fsi-24"
};
const _hoisted_32 = {
  style: {
    "margin-left": "-8px",
    "margin-top": "8px",
    "height": "24px"
  }
};
const _hoisted_33 = {
  class: "row mt-lg-3 mt-0 mb-lg-0 mb-5"
};
const _hoisted_34 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_35 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_36 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_37 = {
  class: "fw-bold fsi-24"
};
const _hoisted_38 = {
  class: "fw-bold fsi-24"
};
const _hoisted_39 = {
  style: {
    "margin-left": "-8px",
    "margin-top": "8px",
    "height": "24px"
  }
};
const _hoisted_40 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_41 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_42 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_43 = {
  class: "fw-bold fsi-24"
};
const _hoisted_44 = {
  class: "fw-bold fsi-24"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "rgba(231,231,231,0.7)",
    "margin-top": "20px"
  }
}, null, -1));
const _hoisted_46 = {
  class: "row mt-4 mb-lg-0 mb-3"
};
const _hoisted_47 = {
  class: "col-12"
};
const _hoisted_48 = {
  class: "d-flex align-items-center flex-lg-row flex-column",
  style: {
    "padding-left": "40px",
    "padding-right": "40px",
    "line-height": "1.5"
  }
};
const _hoisted_49 = {
  class: "mr-3 mb-lg-0 mb-2",
  style: {
    "color": "rgb(120, 122, 155)",
    "font-size": "12px"
  }
};
const _hoisted_50 = {
  class: "flex-center"
};
const _hoisted_51 = {
  class: "mr-4"
};
const _hoisted_52 = ["href"];
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer",
  src: _imports_1,
  style: {
    "width": "70px"
  },
  alt: ""
}, null, -1));
const _hoisted_54 = [_hoisted_53];
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://skynet.certik.com/zh-CN/projects/stfil",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "90px"
  },
  alt: ""
})])], -1));
const _hoisted_56 = {
  class: "mt-3 border-radius-20 dashboard-card",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_57 = {
  class: "row"
};
const _hoisted_58 = {
  class: "col-md-8 col-12 pt-4 pb-3 order-md-1 order-2",
  style: {
    "padding-left": "40px",
    "padding-right": "40px"
  }
};
const _hoisted_59 = {
  class: "fw-bold fsi-14 mb-2"
};
const _hoisted_60 = {
  class: "fw-medium fsi-14 mb-3",
  style: {
    "color": "rgba(120,122,155,0.8)"
  }
};
const _hoisted_61 = ["href"];
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-4 col-12 p-2 order-md-2 order-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "100%",
    "border-radius": "20px"
  },
  class: "mr-3 d-flex justify-content-center align-items-center align-content-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {
    "width": "70%",
    "max-width": "150px"
  }
})])], -1));
const _hoisted_63 = {
  class: "col-xl-5 col-12 order-xl-2 order-1"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "line-height": "1.8em"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {
    "width": "97px"
  }
})]), /*#__PURE__*/_createElementVNode("p", {
  style: {
    "height": "36px",
    "line-height": "2em",
    "font-size": "20px",
    "text-align": "center",
    "font-weight": "bold",
    "margin": "6px 0 20px 0"
  }
}, "公告"), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, "我局在侦办“3.28”非法利用信息网络案中，查处了网站地址为：https：//www.stfil.io的非法网站， 并依法扣押了一批涉案FIL虚拟币。为查明犯罪事实，请该网站质押用户和借贷用户来我局反映情况并提供相关证据材料，现将有关事项公告如下： "), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, " 一、请携带本人有效身份证件、在该网站质押或借贷的相关记录以及购买FIL虚拟币的相关材料。 "), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, " 二、逾期未向我局反映情况的，依照相关法律法规对该虚拟币予以依法处置。 "), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, " 三、公告期为2024年6月10日至2024年7月10日 "), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, " 单位地址：湖南省汉寿县汉寿大道与天平西路交汇处 "), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, " 联系电话：0736-2197110 "), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, " 咨询时间：周一至周五8：00-12：00 14:30-17:30 "), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "text-align": "right",
    "margin-top": "20px"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, "汉寿县公安局"), /*#__PURE__*/_createElementVNode("p", {
  class: "announceInfo"
}, "2024年6月9日")])], -1));
const _hoisted_65 = {
  style: {
    "padding": "20px 0",
    "width": "100%",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_page_head = _resolveComponent("page-head");
  const _component_ScrollNumber = _resolveComponent("ScrollNumber");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_AfterValue = _resolveComponent("AfterValue");
  const _component_RightStake = _resolveComponent("RightStake");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_page_head, {
    content: _ctx.$t('stake.Introduction')
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('stake.title')), 1)]),
    icon: _withCtx(() => [_hoisted_3]),
    "title-right-tool": _withCtx(() => [_ctx.filPrice !== '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.CurrentFILPrice')), 1), _createElementVNode("span", _hoisted_6, "$" + _toDisplayString(_ctx.filPrice), 1)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["content"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(_ctx.$t('stake.Staked APY')), 1), _ctx.$i18n.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('stake.APY')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, [_createVNode(_component_ScrollNumber, {
    customSignStyle: {
      margin: '0 2px!important'
    },
    style: {
      "height": "53px",
      "line-height": "53px"
    },
    color: "#6752F0",
    unit: "%",
    number: $options.formatPrice($options.formatUnits(_ctx.liquidityRate, 25), 2),
    h: 48
  }, null, 8, ["number"])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('common.Convert to APR')) + _toDisplayString(_ctx.$t('common.APR')), 1)]), _createElementVNode("div", null, [_createVNode(_component_ScrollNumber, {
    customSignStyle: {
      margin: '0 -3px!important'
    },
    unitStyle: {
      margin: '0 0 0 0px'
    },
    style: {
      "height": "16px",
      "line-height": "16px"
    },
    color: "#6752F0",
    unit: "%",
    number: _ctx.liquidityRateApr,
    h: 14
  }, null, 8, ["number"])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(_ctx.$t('stake.NetAPYTip')) + " ", 1), _createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.gotNetAPYTip && $options.gotNetAPYTip(...args)),
    class: "link-text"
  }, _toDisplayString(_ctx.$t('stake.LearnMore')), 1)])])]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('stake.TotalSupply')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.supplyBalanceLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      unit: "FIL",
      customStyle: {
        margin: '0 -0.5px'
      },
      unitStyle: {
        margin: '0 0 0 1px'
      },
      number: $options.externalFormatFilPrice(_ctx.supplyBalance, 2, true, false),
      h: 24
    }, null, 8, ["customStyle", "number"])])]),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.supplyBalance,
    "new-value": _ctx.afterSupplyBalance
  }, null, 8, ["old-value", "new-value"])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('dashboard.AvailableLiquidity')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolStFilBalanceLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      unit: "FIL",
      customStyle: {
        margin: '0 -0.5px'
      },
      unitStyle: {
        margin: '0 0 0 1px'
      },
      number: $options.formatWalletFilPrice(_ctx.poolStFilBalanceBig, 2, true, false, false),
      h: 24
    }, null, 8, ["customStyle", "number"])])]),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.poolStFilBalanceBig,
    "new-value": _ctx.afterPoolStFilBalanceBig
  }, null, 8, ["old-value", "new-value"])])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('stake.UtilizationRate')), 1)]), _createVNode(_component_i_skeleton, {
    loading: (_ctx.variableDebtTokenTotalSupplyLoading || _ctx.stableDebtTokenTotalSupplyLoading || _ctx.totalStakingTokensLoading) && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      customStyle: {
        margin: '0 -0.5px'
      },
      unit: "%",
      unitStyle: {
        margin: '0 0 0 1px'
      },
      number: _ctx.utilizationRateFloat,
      h: 24
    }, null, 8, ["customStyle", "number"])])]),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_AfterValue, {
    "is-eth": false,
    suffix: "%",
    units: 2,
    "old-value": _ctx.utilizationRate,
    "new-value": _ctx.afterUtilizationRate
  }, null, 8, ["old-value", "new-value"])])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('dashboard.Stakers')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.tvlLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      customStyle: {
        margin: '0 -0.5px'
      },
      unitStyle: {
        margin: '0 0 0 1px'
      },
      number: _ctx.stakeCount,
      h: 24
    }, null, 8, ["customStyle", "number"])])]),
    _: 1
  }, 8, ["loading"])])])]), _hoisted_45, _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('common.AUDITED SECURED BY')), 1), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("a", {
    href: `${_ctx.docsUrlPrefix}protocol/an-quan-shen-ji`,
    target: "_blank"
  }, _hoisted_54, 8, _hoisted_52)]), _hoisted_55])])])])]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('stake.WhatDoYouGainWhenHoldStFIL')), 1), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('stake.WhatDoYouGainWhenHoldStFILTip')), 1), _createElementVNode("a", {
    target: "_blank",
    href: `${_ctx.docsUrlPrefix}tokenomics/stfil`,
    style: {
      "text-decoration": "none",
      "display": "inline-block",
      "padding": "8px 20px",
      "border-radius": "20px"
    },
    class: "fw-medium fs-12 cursor-pointer mb-1 learn-more"
  }, _toDisplayString(_ctx.$t('stake.LearnMore')), 9, _hoisted_61)]), _hoisted_62])])])]), _createElementVNode("div", _hoisted_63, [_createVNode(_component_RightStake)])])]), _createVNode(_component_el_dialog, {
    class: "announceDialog",
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dialogVisible = $event),
    title: "公告",
    "align-center": "",
    width: "680"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_65, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => $options.confirm())
    }, {
      default: _withCtx(() => [_createTextVNode(" 确认 ")]),
      _: 1
    })])]),
    default: _withCtx(() => [_hoisted_64]),
    _: 1
  }, 8, ["modelValue"])]);
}